// Specimen-related constants shared across LIMS pages

export const SPECIMEN_STATUS_I18N_KEYS: Record<string, string> = {
  available: 'specimen.statuses.available',
  unavailable: 'specimen.statuses.unavailable',
  unsatisfactory: 'specimen.statuses.unsatisfactory',
  'entered-in-error': 'specimen.statuses.entered-in-error',
  unknown: 'specimen.statuses.unknown',
  linked: 'specimen.statuses.linked',
};

// Condition i18n keys (replaces the old quality extension)
export const SPECIMEN_CONDITION_I18N_KEYS: Record<string, string> = {
  satisfactory: 'specimen.conditions.satisfactory',
  unsatisfactory: 'specimen.conditions.unsatisfactory',
};

// Specimen statuses based on FHIR specification
export const SPECIMEN_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  UNSATISFACTORY: 'unsatisfactory',
  ENTERED_IN_ERROR: 'entered-in-error',
} as const;
